<template>
  <fieldset
    class="fieldSet mb-2 pb-1 pl-4 pr-3"
  >
    <legend> 選択済み</legend>
    <p class="fieldLabel">
      件数 :
      <span class="numberInput">
        {{ selectedNum }}
      </span>
    </p>

    <p class="fieldLabel">
      総給油量 :
      <span class="numberInput">
        {{ selectedOilingCapacity }}
      </span>
    </p>
    <MapIcon
      @click="$emit('show-map')"
    />
  </fieldset>
</template>

<script>
import { mapGetters } from 'vuex'
import { MapIcon } from './Map'
export default {
  name: 'Fieldset',
  components: {
    MapIcon
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('list', ['selectedNum', 'selectedOilingCapacity'])
  }
}
</script>

<style lang="scss" scoped>
.fieldSet{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: snow;
  color: var(--metal-grey);
  font-size: 0.7rem;
  border-radius: 10px;
  width: 270px;
  margin-left: auto;
}

.fieldLabel {
  color: var(--metal-grey-d);
  margin: 0;
  white-space: nowrap;
}

.numberInput{
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
}
</style>
